import { configureStore } from '@reduxjs/toolkit'
import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'
import { combineReducers } from 'redux'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import catalogStore from '@/core/store/catalog.store'
import uiState from '@/core/store/ui.store'

const rootReducer = combineReducers({
  catalogStore: persistReducer(
    {
      key: 'catalog',
      storage: storage,
      whitelist: ['catalogType', 'playedAudioIds', 'isPayedClient', 'gotTutorial', 'payedTours'],
    },
    catalogStore,
  ),
  uiState,
})

// const rootReducer = combineReducers({
//   catalogStore,
//   uiState,
// })

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
